/**
 * Created by abdulhafeth on 12/10/15.
 */

angular.module('harriApp')
    .directive('dateRangePicker', ['deviceChecker', function (deviceChecker) {
        return {
            restrict: 'E',
            templateUrl: '../modules/forms/components/dateRangePicker/date_range_picker.html',
            scope: {
                ngModel: '=',
                name: '@',
                ngChange:'=',
                ngClear: '&',
                dateFormat: '@',
                minValue: "=?",
                maxValue: "=?",
                showClear: "=?",
                fromLabel: "@?",
                toLabel:"@?",
                fromClass: "@?",
                toClass: "@?"
            },
            link: function ($scope, element, attrs) {
                $scope.dateFormat = $scope.dateFormat || "MMMM DD, YYYY";
                $scope.ngChange =  $scope.ngChange || function(){};
                $scope.from_date_id = "from_date";
                $scope.to_date_id = "to_date";
                $scope.minValue = $scope.minValue || moment().subtract(15, 'years').toDate();
                $scope.maxValue = $scope.maxValue || moment().add(15, 'years').toDate();
                $scope.fromLabel = $scope.fromLabel || $filter("translate")("From");
                $scope.toLabel = $scope.toLabel || $filter("translate")("To");
                $scope.fromClass = $scope.fromClass || "col-xs-12 col-12";
                $scope.toClass = $scope.toClass || "col-xs-12 col-12";
                var defaultModel = {
                    start_date: $scope.minValue,
                    end_date: $scope.maxValue
                };

                $scope.ngModel = $scope.ngModel || defaultModel;

                $scope.startDate = $scope.ngModel.start_date;
                $scope.endDate = $scope.ngModel.end_date;

                $scope.clear = function(id){
                    if(id == $scope.from_date_id){
                        $scope.startDate =  undefined;
                        $scope.ngModel.start_date = "";
                        element.find("#from_date_id").find('input').val("");
                    }

                    if(id == $scope.to_date_id){
                        $scope.endDate =  $scope.maxValue?moment($scope.maxValue):$scope.endDate;
                        $scope.ngModel.end_date = "";
                        element.find("#to_date_id").find('input').val("");
                    }

                    setTimeout(function(){
                        element.trigger("change");
                        $scope.ngChange($scope.ngModel);
                    }, 100);

                };

                // handle date picker events
                setTimeout(function () {
                    element.find("#from_date_id").change(function () {
                        var val = $(this).find('input').val();
                        var startDateMoment;
                        if(val) {
                            startDateMoment = moment($(this).find('input').val(), $scope.dateFormat);
                            if (deviceChecker.isMobile()) {
                                // date input convention yyyy-MM-dd when the input type is date
                                // mobile we use the native date input and angular going sad
                                // so we need to format it as format we have
                                startDateMoment = moment($(this).find('input').val(), "YYYY-MM-DD");
                                // set min to date picker in mobile
                                $scope.startDate = $(this).find('input').val() ? startDateMoment.toDate() : $scope.minValue;
                            }
                        }

                        $scope.startDate = startDateMoment;

                        if ($scope.startDate) {
                          $scope.ngModel.start_date = startDateMoment.format($scope.dateFormat);
                          if ($scope.isFromCalendarOpen) {
                            $scope.isToCalendarOpen = false;
                          }

                        } else {
                            $scope.startDate =  $scope.minValue?moment($scope.minValue):$scope.startDate;
                            $scope.ngModel.start_date = "";
                        }

                        setTimeout(function () {
                            $scope.$digest();
                            element.trigger("change");
                            $scope.ngChange($scope.ngModel);
                        }, 1);
                    });

                    element.find("#to_date_id").change(function () {
                        var val = $(this).find('input').val();
                        var endDateMoment;
                        if(val) {
                            var endDateMoment = moment($(this).find('input').val(), $scope.dateFormat);
                            $scope.endDate = endDateMoment;
                            if (deviceChecker.isMobile()) {
                                // date input convention yyyy-MM-dd when the input type is date
                                // mobile we use the native date input and angular going sad
                                // so we need to fromat it as format we have
                                endDateMoment = moment($(this).find('input').val(), "YYYY-MM-DD");
                                // set max to date picker in mobile
                                $scope.endDate = endDateMoment.toDate();
                            }
                        }

                        $scope.endDate = endDateMoment;
                        if ($scope.endDate) {
                          $scope.ngModel.end_date = endDateMoment.format($scope.dateFormat);
                          if ($scope.isToCalendarOpen) {
                            $scope.isFromCalendarOpen = false;
                          }
                        } else {
                            $scope.endDate =  $scope.maxValue?moment($scope.maxValue):$scope.endDate;
                            $scope.ngModel.end_date = "";
                        }

                        setTimeout(function () {
                            $scope.$digest();
                            element.trigger("change");
                            $scope.ngChange($scope.ngModel);
                        }, 500);
                    });

                    element.find("#from_date_id").on('toggle', function () {
                        if ($scope.isFromCalendarOpen) {
                            $scope.isToCalendarOpen = false;
                        }

                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);
                    });

                    element.find("#to_date_id").on('toggle', function () {
                        if ($scope.isToCalendarOpen) {
                            $scope.isFromCalendarOpen = false;
                            setTimeout(function () {
                                $scope.$digest();
                            }, 1);
                        }
                    });
                }, 200);
            }
        }
    }]);
